import React from 'react';

const items = [
  {
    title: 'Op maat gemaakt',
    description: 'Elk voertuig is uniek. Wij analyseren uw wensen tot in detail en stellen een plan samen dat volledig is afgestemd op uw auto en uw verwachtingen.',
  },
  {
    title: 'Premium kwaliteit',
    description: 'Wij werken uitsluitend met de beste materialen en technieken uit de industrie. Van PPF tot chiptuning, elk onderdeel voldoet aan de hoogste standaard.',
  },
  {
    title: 'Volledig ontzorgd',
    description: 'Van het eerste consult tot de oplevering verzorgen wij het complete traject. U levert uw voertuig in en rijdt weg met een vlekkeloos resultaat.',
  },
  {
    title: 'Levenslange relatie',
    description: 'Onze service stopt niet bij oplevering. Wij bieden garantie op al onze werkzaamheden en blijven beschikbaar voor onderhoud en nazorg.',
  },
];

const ValuePropositions = () => {
  return (
    <section className="bg-white py-20 md:py-28 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {items.map((item, i) => (
            <div key={i}>
              <div className="h-px bg-black/80 mb-7" />
              <h3
                className="text-black font-semibold text-[15px] md:text-base mb-3 tracking-[0.08em] uppercase"
                style={{ fontFamily: "'Manrope', sans-serif", lineHeight: 1.3 }}
              >
                {item.title}
              </h3>
              <p
                className="text-black/50 text-[13px] leading-[1.7]"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePropositions;
